module.exports = __webpack_public_path__ + "img/header-engagementRingsCharacter.ab15dd5.jpg";